import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, applyBrand } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [settings, setSettings] = useState(null);

  const loadSettings = useCallback(() => api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}), []);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    const onLogout = () => setUser(false);
    window.addEventListener("auth:logout", onLogout);
    return () => window.removeEventListener("auth:logout", onLogout);
  }, []);
  useEffect(() => { if (user) loadSettings(); }, [user, loadSettings]);
  useEffect(() => { applyBrand(settings?.brand); }, [settings]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data);
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, login, logout, settings, setSettings, loadSettings }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
